import { GenderMaleIcon, GenderFemaleIcon } from '@honestica/curecall-ui'
import { EPatientGender } from 'src/types/patient'
import type { TPatient } from 'src/types/patient'
import { twMerge } from 'src/utils/tw-merge.util'

interface PatientGenderIconProps {
  patient: Pick<TPatient, 'gender'>
  className?: string
}

const PatientGenderIcon = ({ patient, className }: PatientGenderIconProps) => {
  if (patient.gender === EPatientGender.FEMALE) {
    return <GenderFemaleIcon className={twMerge('c-h-10', className)} />
  }

  if (patient.gender === EPatientGender.MALE) {
    return <GenderMaleIcon className={twMerge('c-h-10', className)} />
  }

  return null // Gender = 'NA' || 'UNKNOWN'
}

export default PatientGenderIcon
